import { render, staticRenderFns } from "./PointListDefaultLayout.vue?vue&type=template&id=2678325a&scoped=true&"
import script from "./PointListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PointListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678325a",
  null
  
)

export default component.exports